<template>
  <div class="selected-coin">
    <div class="info">
      <img
        class="coin-icon"
        :src="$coins[$route.params.tradeFrom].link"
        alt=""
      />
      <div class="coinlabel">
        <span class="tradeto">
          {{
            $coins[$route.params.tradeFrom].persianName +
            " " +
            $coins[$route.params.tradeTo].persianName
          }}
        </span>
        <span> / </span>
        <span class="tradefrom">
          {{ $coins[$route.params.tradeTo].persianName }}
        </span>
      </div>
      <span>
        {{
          $toLocal(
            marketTradeInfo.lastPrice,
            $coins[$route.params.tradeTo].precision
          )
        }}
      </span>
      <div class="changes">
        <inline-svg
          :class="marketTradeInfo.last24HourChange > 0 ? 'success' : 'fail'"
          :src="require('../../assets/icons/changes.svg')"
        />
        <span class="success" v-if="marketTradeInfo.last24HourChange > 0">
          {{ $toLocal(marketTradeInfo.last24HourChange, 2) }}%+</span
        >
        <span class="fail" v-if="marketTradeInfo.last24HourChange < 0">
          {{ $toLocal(Math.abs(marketTradeInfo.last24HourChange), 2) }}%-
        </span>
        <span class="fail" v-if="marketTradeInfo.last24HourChange == 0">
          0
        </span>
      </div>
    </div>
    <div class="table">
      <table>
        <tr class="title-head">
          <td>کمترین قیمت</td>
          <td>بالاترین قیمت</td>
          <td>حجم بازار</td>
        </tr>
        <tr>
          <td>
            {{ $toLocal(marketTradeInfo.minPrice) }}
            <span class="coin-label">{{
              $coins[$route.params.tradeTo].persianName
            }}</span>
          </td>
          <td>
            {{ $toLocal(marketTradeInfo.maxPrice) }}
            <span class="coin-label">{{
              $coins[$route.params.tradeTo].persianName
            }}</span>
          </td>
          <td>
            {{ $toLocal(marketTradeInfo.last24HourVolume) }}
            <span class="coin-label">{{
              $coins[$route.params.tradeTo].persianName
            }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "CoinHeaderP2P",
  props: ["marketTradeInfo"],

  // mounted() {
  //   this.beforeLoop();
  // },
  // beforeDestroy() {
  //   if (this.loop) {
  //     this.loop.stop();
  //   }
  // },
};
</script>

<style lang="scss" scoped>
.title-head {
  td {
    color: rgba(79, 79, 79, 1);
  }
}
.changeicon {
  width: 18px;
  height: 12px;
}
.coin-label {
  color: var(--grey);
  font-weight: 400;
  font-size: clamp(10px, 1vw, 12px);
}
.table {
  width: 45%;
}
table {
  width: 100%;
}
.selected-coin {
  display: flex;
  flex-direction: row;
  padding: 8px 12px;
  background: var(--box);
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  width: 80%;
}
.info {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
  .coinlabel {
    display: flex;
    flex-direction: row;
    column-gap: 12px;
    align-items: center;
  }
  .coin-icon {
    width: 26px;
    height: 26px;
  }
  .tradeto {
    word-spacing: 2px;
    align-items: center;
  }
  .tradefrom {
    color: var(--grey);
    font-size: clamp(12px, 1vw, 14px);
  }
  .changes {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    justify-content: center;
    align-items: center;
    svg {
      width: 18px !important;
      height: 12px !important;
    }
  }
}
@media only screen and (max-width: 1300px) {
  .selected-coin {
    justify-content: center;
    width: 100%;
  }
}
@media only screen and (max-width: 1000px) {
  .table {
    display: none;
  }
  .selected-coin {
    justify-content: center;
  }
}
@media only screen and (max-width: 650px) {
  .coinlabel {
    display: none !important;
  }
  .info {
    width: 100%;
    justify-content: space-between;
    .changes {
      font-size: 12px;
    }
  }
}
</style>
